export const GET_CANCERS = "/api/endpoint/get_cancers";
export const REST_USER = "/api/user/";
export const GET_STUDY = "/api/endpoint/get_study_list";
export const GET_CONSENT = "/api/endpoint/get_consent";
export const DONATION_INFO = "/api/consent/join/";
export const PASSCODE = "/api/auth/passcode/";
export const LOGIN = "/api/auth/login/";
export const GET_STATIC_STUFF = "/api/content/all/";